export default "__VITE_ASSET__CiAnPcGZ__"